/**
 * Created by r4zi4l on 02.04.2021
 */

const ThirdElementView = cc.Node.extend({
    ctor: function (thirdElement, unitView) {
        this._super();

        this.thirdElement = thirdElement;
        this.unitView = unitView;

        this.createPrize();
        this.createTimer();
    },

    createPrize: function () {
        const prize = this.prize = UnitView.getUnitImage(this.thirdElement.prize, {
            alignAnchorX: true,
            alignAnchorY: true
        });
        prize.setLocalZOrder(-1);
        this.unitView.addChild(prize);
        this.prize.setPosition(this.unitView.width / 2, this.unitView.height / 2);
    },

    createTimer: function () {
        const styles = cleverapps.styles.ThirdElementView.timer;

        const timer = this.timer = new cleverapps.CountDownView(new cleverapps.CountDown(this.thirdElement.getTimeLeft()), {
            font: cleverapps.styles.FONTS.THIRD_ELEMENT_TIMER_TEXT,
            background: {
                frame: bundles.small_timer_merge.frames.timer_bg_png,
                width: styles.width,
                height: styles.height
            },
            icon: {
                frame: bundles.small_timer_merge.frames.timer_png,
                json: bundles.small_timer.jsons.small_timer_json,
                animation: "animation"
            },
            showHours: false
        });
        timer.setAlignment(styles);

        cleverapps.UI.onClick(this, this.thirdElement.unit.handleClick.bind(this.thirdElement.unit));

        this.unitView.createAdditionalView("timer", timer, true);
    },

    bubbleAppearance: function () {
        const styles = cleverapps.styles.ThirdElementView;

        const sprite = this.unitView.sprite;
        const prize = this.prize;

        this.unitView.hideAdditionalView("timer", true);
        sprite.setAnimationAndIdleAfter("appearance", "idle");

        cleverapps.UI.fitToBox(prize, {
            width: sprite.width * styles.prize.scale,
            height: sprite.height * styles.prize.scale
        });

        const prizeBaseScale = prize.getScale();
        const offsetY = styles.hoveringAnimation.offsetY;

        prize.setOpacity(50);
        prize.setScale(prizeBaseScale * 0.2);

        prize.setPositionY(prize.y + styles.bubble.offset.y);

        prize.setRotation(-110);

        prize.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("thirdelement.appear"),
            new cc.Spawn(
                new cc.FadeIn(0.1),
                new cc.RotateTo(0.6, 0).easing(cc.easeBackOut()),
                new cc.ScaleTo(0.6, prizeBaseScale).easing(cc.easeBackOut()),
                new cc.MoveBy(0.6, 0, -offsetY)
            ),
            new cc.DelayTime(0.5),
            StandartAnimations.hovering(prize, {
                animationTime: sprite.getAnimationDuration("idle"),
                offsetY: -offsetY,
                rightAngle: 0,
                leftAngle: -10
            }),
            new cc.CallFunc(() => {
                this.unitView.showAdditionalView("timer");
            })
        ));
    },

    playDestruction: function (cb) {
        this.unitView.removeAdditionalView("timer");

        const scaleX = this.prize.getScaleX();
        const scaleY = this.prize.getScaleY();

        this.prize.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            cleverapps.effects.fireAction("thirdelement.destroy")
        ));

        this.prize.runAction(new cc.Sequence(
            new cc.ScaleTo(0.82, scaleX * 1.3, scaleY * 1.3).easing(cc.easeOut(1)),
            new cc.Hide(),
            new cc.CallFunc(() => {
                cb && cb();
            })
        ));
    },

    playBuying: function (unit, options) {
        options = options || {};

        const unitView = this.unitView;

        cleverapps.pointerManager.removeAll(this, true);

        unitView.hideAdditionalViews();

        this.boughtUnitView = unit.onGetView();
        this.boughtUnitView.sprite.setVisible(false);

        this.prize.replaceParentSamePlace(this.boughtUnitView);

        this.buyingListener = Merge2.current.field.on("onUnitRemoved", (removedUnit) => {
            if (removedUnit === unit) {
                this.finishBuying();
            }
        }, this);

        const prize = this.prize;
        prize.stopAllActions();

        const basePosition = cc.p(this.boughtUnitView.width / 2, this.boughtUnitView.height / 2);

        if (options.keepInPlace) {
            prize.runAction(new cc.Sequence(
                new cc.DelayTime(options.delay || 0),
                new cc.Spawn(
                    new cc.ScaleTo(0.3, 1).easing(cc.easeInOut(2)),
                    new cc.RotateTo(0.3, 0).easing(cc.easeInOut(2)),
                    new cc.MoveTo(0.3, basePosition)
                ),
                cleverapps.effects.fireAction("thirdelement.destroy")
            ));
        } else {
            prize.runAction(new cc.Sequence(
                new cc.Spawn(
                    new cc.ScaleTo(0.7, 1.1).easing(cc.easeInOut(2)),
                    new cc.RotateTo(0.7, 20).easing(cc.easeInOut(2)),
                    new cc.MoveTo(0.7, basePosition)
                ),
                new cc.Spawn(
                    new cc.Sequence(
                        new cc.ScaleTo(0.6, 0.9).easing(cc.easeInOut(2)),
                        new cc.ScaleTo(0.4, 1).easing(cc.easeInOut(2))
                    ),
                    new cc.RotateTo(0.7, 0).easing(cc.easeInOut(2)),
                    new cc.DelayTime(0.5),
                    cleverapps.effects.fireAction("thirdelement.destroy")
                )
            ));
        }

        unitView.sprite.runAction(new cc.Sequence(
            new cc.DelayTime(options.delay || 0),
            new cc.CallFunc(() => {
                unitView.sprite.setAnimation(0, options.animation || "disappearance", false);
                unitView.sprite.setCompleteListenerOnce(this.finishBuying.bind(this));
            })
        ));
    },

    finishBuying: function () {
        if (this.buyingFinished) {
            return;
        }
        this.buyingFinished = true;

        if (this.buyingListener) {
            this.buyingListener.clear();
            this.buyingListener = undefined;
        }

        const unitView = this.unitView;

        unitView.sprite.setCompleteListener();

        this.prize.stopAllActions();
        this.prize.removeFromParent();

        unitView.stopAllActions();
        unitView.removeFromParent();

        this.boughtUnitView.sprite.setVisible(true);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    THIRD_ELEMENT_TIMER_TEXT: {
        size: 20,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.ThirdElementView = {
    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 0 },
        width: 115,
        height: 35
    },

    hoveringAnimation: {
        offsetY: 10
    },

    prize: {
        x: { align: "center" },
        y: 322,
        scale: 0.7
    },

    bubble: {
        offset: {
            y: -6
        }
    }
};
